import React from 'react';
import 'src/assets/scss/reset.scss'
import 'src/assets/scss/Components.scss'

interface Props{
    title:string
    content
    errorModalOpen:boolean 
    handleErrorModal
    
}

const ErrorModal: React.FC<Props> = (props: Props) =>{
   
  return (
    <div className="modal-shadow" style={{display :props.errorModalOpen ? "flex" : "none"}}>
        <div className="modal">
        <div className='modal-background'>
            <div className="modal-title">
                {props.title}
            </div>
            <div className="modal-content">
                {props.content}
            </div>
            </div>
            <div className="modal-actions">
                <div className="modal-actions-export" onClick={() => props.handleErrorModal(props.title)}>확인</div>
            </div>
        </div>
    </div>
  );
};


export default ErrorModal 